import { createContext, useReducer } from "react";
import * as types from "./types";

const initialState = {
  audio: true,
  video: true,
  room: {},
  connectedRoom: {},
  currentQuestion: 0,
  evidenceInProgressInstance: {},
  dnsdSid: null,
  isEvidenceCompleted: true,
  isCallEnded: false,
  questionPayloadInStore: {},
  auditSubmitted: false,
  isCameraPermissionChecked: false,
  isMultipleCamera: false,
  selectedCamera: "user",
  showQuestion: false,
  mutedParticipent: {},
  mutedVideoParticipent: {},
};

const remoteAuditReducer = (state, action) => {
  switch (action.type) {
    case types.SET_AUDIO_STATUS:
      return {
        ...state,
        audio: action.payload,
      };
    case types.SET_VIDEO_STATUS:
      return {
        ...state,
        video: action.payload,
      };
    case types.SET_ROOM_STATUS:
      return {
        ...state,
        room: action.payload,
      };
    case types.SET_CONNECTED_ROOM:
      return {
        ...state,
        connectedRoom: action.payload,
      };
    case types.SET_CURRENT_QUESTION:
      return {
        ...state,
        currentQuestion: action.payload,
      };
    case types.EVIDENCE_INPROGRESS_INSTANCE:
      return {
        ...state,
        evidenceInProgressInstance: action.payload,
      };
    case types.SET_DNSD_SID:
      return {
        ...state,
        dnsdSid: action.payload,
      };
    case types.IS_EVIDENCE_COMPLETED:
      return {
        ...state,
        isEvidenceCompleted: action.payload,
      };
    case types.SET_CALL_ENDED:
      return {
        ...state,
        isCallEnded: action.payload,
      };
    case types.SET_QUESTION_PAYLOAD:
      return {
        ...state,
        questionPayloadInStore: action.payload,
      };
    case types.SET_AUDIT_SUBMITTED:
      return {
        ...state,
        auditSubmitted: action.payload,
      };
    case types.SET_MULTIPLE_CAMERA:
      return {
        ...state,
        isCameraPermissionChecked: true,
        isMultipleCamera: action.payload,
      };
    case types.SET_SELECTED_CAMERA:
      return {
        ...state,
        selectedCamera: action.payload,
      };

    case types.SET_SHOW_QUESTION:
      return {
        ...state,
        showQuestion: action.payload,
      };
    case types.SET_MUTED_PARTICIPENT_CONTEXT:
      return {
        ...state,
        mutedParticipent: action.payload,
      };
    case types.SET_MUTED_VIDEO_PARTICIPENT_CONTEXT:
      return {
        ...state,
        mutedVideoParticipent: action.payload,
      };
    default:
      return state;
  }
};

export const RemoteAuditContext = createContext(initialState);

export const RemoteAuditProvider = ({ children }) => {
  const [remoteAuditState, remoteAuditDispatch] = useReducer(
    remoteAuditReducer,
    initialState
  );

  return (
    <RemoteAuditContext.Provider
      value={[remoteAuditState, remoteAuditDispatch]}
    >
      {children}
    </RemoteAuditContext.Provider>
  );
};

export default RemoteAuditProvider;
